import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  onStatusChange(callback: (isOffline: boolean) => void) {
    window.addEventListener('offline', () => callback(true));
    window.addEventListener('online', () => callback(false));
    callback(!navigator.onLine);
  }
}
